import { Box, Container, Tab, Tabs } from '@mui/material';
import React, { SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '../../store/hooks';
import langFile from '../../data/lang.json';
const useQuery = () => new URLSearchParams(window.location.search);

interface MainProps {
    active: number;
    children?: React.ReactNode;
}

const Main: React.FC<MainProps> = (props) => {
    const navigate = useNavigate();
    const query = useQuery();
    const embedded = query.get('embedded');
    const { lang } = useTypedSelector((state) => state.common);

    const handleChange = (e: SyntheticEvent, value: number) => {
        if (value === 0) navigate(embedded === 'true' ? '/loans?embedded=true' : '/loans');
        else if (value === 1) navigate(embedded === 'true' ? '/deposits?embedded=true' : '/deposits');
        else if (value === 2) navigate('/developers');
    };

    return (
        <Container
            maxWidth="md"
            sx={{
                backgroundColor: '#fff',
                pb: 4,
            }}
        >
            <Tabs value={props.active} centered onChange={handleChange}>
                <Tab label={(langFile.loanFormTitle as any)[lang]} />
                <Tab label={(langFile.depositFormTitle as any)[lang]} />
                {embedded === 'true' ? null : <Tab label={(langFile.developersTitle as any)[lang]} />}
            </Tabs>
            {props.children}
        </Container>
    );
};

export default Main;
